import React from 'react';
import styled from '@emotion/styled';
import FooterLinks from './FooterLinks';
import FooterInfo from './FooterInfo';

const Wrapper = styled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 4.8rem;
  min-height: 4.8rem;
  background-color: white;
  justify-content: space-between;

  @media (max-width: 66.5rem) {
    padding: 1.25rem 0;
    flex-direction: column;
  }
`;

interface Props {
  appVersion: string;
}

export const Footer = (props: Props) => {
  return (
    <Wrapper>
      <FooterLinks />
      <FooterInfo appVersion={props.appVersion} />
    </Wrapper>
  );
};

export default Footer;
